var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "folder-card",
      attrs: { outlined: "" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-space-between align-start" },
        [
          _c("div", [
            _c("div", { staticClass: "font-weight-bold text-body-1" }, [
              _vm._v(_vm._s(_vm.folder.name)),
            ]),
            _c("div", { staticClass: "text-caption grey--text" }, [
              _vm._v(
                " " + _vm._s(_vm.folder.sub_folder.length) + " Subcarpetas "
              ),
            ]),
            _vm.folder.documents
              ? _c("div", { staticClass: "text-caption grey--text" }, [
                  _vm._v(_vm._s(_vm.folder.documents.length) + " Documentos"),
                ])
              : _vm._e(),
          ]),
          _vm.canEditDelete
            ? _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-icon",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "grey--text text--darken-2",
                                    attrs: { small: "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  "v-icon",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_vm._v(" mdi-dots-vertical ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1157744019
                  ),
                },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("editItem", _vm.folder)
                            },
                          },
                        },
                        [_c("v-list-item-title", [_vm._v("Editar")])],
                        1
                      ),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("deleteItem", _vm.folder)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-title",
                            { staticClass: "red--text" },
                            [_vm._v("Eliminar")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-end mt-15" },
        [
          _c("v-icon", { attrs: { color: _vm.folder.color, size: "36" } }, [
            _vm._v("mdi-folder"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }